import type { Database } from '../../types/database.generated'
export type Task = Database['public']['Tables']['tasks']['Row']
export type TaskComment = Database['public']['Tables']['task_comments']['Row']
export type TaskActivity = Database['public']['Tables']['task_activity']['Row']
export type TaskPriority = Database['public']['Enums']['task_priority']
export type TaskStatus = Database['public']['Enums']['task_status']
export type TaskEvidenceStage = Database['public']['Enums']['task_evidence_stage']
export type TaskEvidence = Database['public']['Tables']['task_evidence']['Row']
export interface TaskEvidenceItem extends TaskEvidence {
  document_title: string
  file_name: string
  mime_type: string
  storage_path: string
}
export interface TaskWorkspace { tasks: Task[]; comments: TaskComment[]; activity: TaskActivity[]; evidence: TaskEvidenceItem[]; assessmentId: string|null; actions:Array<{id:string;question_id:string|null;title:string}>; questions:Array<{id:string;prompt:string}>; documents:Array<{id:string;title:string}>; members:Array<{userId:string;label:string}> }
export function isTaskOverdue(task: Task, today=new Date()){ if(!task.due_date||['completed','cancelled'].includes(task.status)) return false; const due=new Date(`${task.due_date}T23:59:59`); return due<today }
